import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class CatalogoApiService {


  data: any[] = [];

  catalogosURL: string = config.API_DATA_URL + '/Catalogos';

  constructor(public http: HttpClient) {}

  /*************************************
   * Tipo Plan de Trabajo
   *************************************/
  public GetTipoPlanTrabajo(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetTipoPlanTrabajo', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  /*************************************
   * Catalogo de Clientes
   *************************************/
  public GetClientes(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetClientes', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarCliente(cliente: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(cliente);
    return this.http.post(this.catalogosURL + '/AgregarCliente', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarCliente(cliente: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(cliente);
    return this.http.post(this.catalogosURL + '/ActualizarCliente', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarCliente(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarCliente/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public EliminarCliente(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarCliente/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }
  //////////////////////// FIN Clientes ///////////////////////////

  /*************************************
   * Catalogo de Aseguradoras
   *************************************/
  public GetAseguradoras(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetAseguradoras', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarAseguradora(aseguradora: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(aseguradora);
    return this.http.post(this.catalogosURL + '/AgregarAseguradora', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarAseguradora(aseuradora: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(aseuradora);
    return this.http.post(this.catalogosURL + '/ActualizarAseguradora', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarAseguradora(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarAseguradora/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public EliminarAseguradora(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarAseguradora/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }
  //////////////////////// FIN Aseguradoras ///////////////////////////

  /*************************************
   * Catalogo de Marcas
   *************************************/
  public GetMarcas(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetMarcas', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarMarca(marca: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(marca);
    return this.http.post(this.catalogosURL + '/AgregarMarca', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarMarca(marca: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(marca);
    return this.http.post(this.catalogosURL + '/ActualizarMarca', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarMarca(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarMarca/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public EliminarMarca(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarMarca/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }
  //////////////////////// FIN Marcas ///////////////////////////


  /*************************************
   * Catálogo de Empleados
   *************************************/

  public GetEmpleados(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetEmpleados', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarEmpleado(empleado: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(empleado);
    return this.http.post(this.catalogosURL + '/AgregarEmpleado', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  
  public AsignarPassword(idEmpleado: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(idEmpleado);
    return this.http.post(this.catalogosURL + '/AsignarPassword', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarEmpleado(empleado: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(empleado);
    return this.http.post(this.catalogosURL + '/ActualizaEmpleado', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public AsignarRol(empleadoRol: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(empleadoRol);
    return this.http.post(this.catalogosURL + '/AsignarRol', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarEmpleado(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarEmpleado/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public EliminarEmpleado(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarEmpleado/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

   //////////////////////// FIN Empleados ///////////////////////////

  /*************************************
   * Catálogo de PROVEEDORES
   *************************************/
  public GetProveedores(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetProveedores', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarProveedor(proveedor: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(proveedor);
    return this.http.post(this.catalogosURL + '/AgregarProveedor', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarProveedor(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarProveedor/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public ActualizarProveedor(proveedor: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(proveedor);
    return this.http.post(this.catalogosURL + '/ActualizaProveedor', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EliminarProveedor(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarProveedor/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  //////////////////////// FIN PROVEEDORES ///////////////////////////

  /*************************************
   * Catalogo de Beneficiario
   *************************************/
  public GetBeneficiarios(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetBeneficiarios', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public AgregarBeneficiario(beneficiario: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(beneficiario);
    return this.http.post(this.catalogosURL + '/AgregarBeneficiario', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarBeneficiario(beneficiario: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(beneficiario);
    return this.http.post(this.catalogosURL + '/ActualizaBeneficiario', param , { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EditarBeneficiario(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EditarBeneficiario/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public EliminarBeneficiario(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/EliminarBeneficiario/' + id.toString(), { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }
  //////////////////////// FIN Beneficiarios ///////////////////////////

  ////////////////// PRINCIPAL //////////////////////////

  public GetResumenPendientes(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.catalogosURL + '/GetResumenPendientes/' + idSucursal, { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  /////////////////// FIN PRINCIPAL /////////////////////////

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/catalogo-api.service.ts